import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'
import { ThemedValues } from 'styles/themed'

export const ThemedItemStyles = StyleSheet.create({
	container: {
		flex: 1,
		flexDirection: 'row',
		height: 'auto',
		minHeight: 'auto',
	},
	
	accessoryLeftContainer: {
		position: 'relative',
		marginTop: 6,
		marginBottom: 6,
		marginLeft: 6,
		marginRight: 6,
	},
	accessoryLeft: {
		width:'100%',
		height: '100%',
		borderRadius: ThemedValues.borderRadius,
		alignItems: 'center',
		justifyContent: 'center',
	},
	
	contentContainer: {
		flex: 1,
		paddingHorizontal: 8,
		marginTop: 4,
		justifyContent: 'center',
		//height: 'auto',
		//minHeight: 'auto',
	},
	contentTitle: {
		fontSize: 16,
		fontWeight: '700',
		marginBottom: 5,
	},
	
	items: {
		//flex: 1,
	},
	
	contentSubTitle: {
		fontSize: 14,
		color: colorList.TEXT.light,
		marginBottom: 5,
	},
	
	actionItemContainer: {
		alignItems: 'flex-start',
		//height: '100%',
		flexDirection: 'row',
		position: 'absolute',
		right: 0,
		top: 4,
	},
	actionItemView: {
		marginHorizontal: 6,
		paddingHorizontal: 4,
		alignItems: 'flex-start',
		justifyContent: 'center',
		height: 30,
	},
	actionItemIcon: {
		color: colorList.ORANGE.primary,
		fontSize: 18,
	}
});
